<template>
  <div class="ctpx-product-item" v-bind:class="{ 'is-dd': product.isDelDia }">
    <!--  if Del Dia is Selected -->
    <a
      v-if="product.isDelDia"
      :href="product.delDiaVersion.url"
      class="product-image"
    >
      <img
        :src="product.delDiaVersion.featuredImage"
        alt="Del Dia Version"
        draggable="false"
        :id="'prod' + product.shopifyProductId"
        class="img-responsive"
        width="400"
        height="400"
        loading="lazy"
      />
      <img
        v-if="!isMobile && product.delDiaVersion.alternateImage != null"
        :src="product.delDiaVersion.alternateImage.url"
        draggable="false"
        class="img-responsive hover-show"
        width="400"
        height="400"
        loading="lazy"
      />
      <span class="btn btn-default">Choose Color</span> </a
    ><!-- .product-image -->
    <!-- if  NOT Del Dia -->
    <a
      v-else
      :href="
        product.url +
        '?colorway=' +
        product.activeColor.replace(/[^A-Z0-9]/gi, '')
      "
      class="product-image"
    >
      <img
        :src="product.featuredImage"
        draggable="false"
        :id="'prod' + product.shopifyProductId"
        class="img-responsive"
        width="400"
        height="400"
        loading="lazy"
      />
      <img
        v-if="!isMobile && product.alternateImage != null"
        :src="product.alternateImage.url.replace('w_1200', 'w_600')"
        draggable="false"
        class="img-responsive hover-show"
        width="400"
        height="400"
        loading="lazy"
      />
      <!--custom badge/color takes precedent over tags-->
      <span
        v-if="product.badgeText"
        class="btn btn-default"
        :style="{ backgroundColor: product.badgeColor }"
        data-nosnippet
        >{{ product.badgeText }}</span
      >
      <span
        v-else-if="product.colorwayStatus === 'Sale'"
        class="btn btn-default sale"
        data-nosnippet
        >Sale</span
      >
      <span
        v-else-if="product.colorwayStatus === 'Final Sale'"
        class="btn btn-default fsale"
        data-nosnippet
        >Final Sale</span
      >
      <span
        v-else-if="
          product.choiceInventory && product.choiceInventory === 'choice'
        "
        class="btn btn-default"
        data-nosnippet
        >Choose Color</span
      >
      <span
        v-else-if="
          product.choiceInventory && product.choiceInventory === 'surprise'
        "
        class="btn btn-default"
        data-nosnippet
        >Surprise Me</span
      >
      <span v-else-if="tagExists('new', product.tags)" class="btn btn-default"
      data-nosnippet
        >New</span
      > </a
    ><!-- .product-image -->
    <div class="product-details">
      <div
        v-if="
          product.wwltTooltipDetails != null &&
          product.wwltTooltipDetails.showTooltip == true
        "
        class=""
        data-nosnippet
      >
        <div
          class="tooltipa"
          v-bind:class="product.wwltTooltipDetails.linkColor"
        >
          <span class="tooltiptitle" v-if="product.wwltTooltipDetails.title">
            <span
              v-if="product.wwltTooltipDetails.icon"
              class="icon"
              v-bind:class="product.wwltTooltipDetails.icon"
            ></span>
            {{ product.wwltTooltipDetails.title }}</span
          >
          <span
            class="tooltiptext"
            v-if="product.wwltTooltipDetails.bubbleInfo"
          >
            {{ product.wwltTooltipDetails.bubbleInfo }}
          </span>
        </div>
      </div>
      <!--  if Del Dia is Selected -->
      <a v-if="product.isDelDia" :href="product.delDiaVersion.url" class="row">
        <div class="col-8 col-sm-9">
          <h6 class="product-title">{{ product.delDiaVersion.title }}</h6>
        </div>
        <!-- .col -->
        <div class="col-4 col-sm-3 text-right" data-nosnippet>
          <!--check that the del dia price difference doesn'get shown as a sale price relative to regular version's price-->
          <!-- {{ formatPrice(product.delDiaVersion.price.toString()) }} -->
          <h6
            class="product-price"
            v-if="
              product.activeCompareAtPrice &&
              Number.parseFloat(product.activeCompareAtPrice) >
                Number.parseFloat(product.delDiaVersion.price) &&
              Number.parseFloat(product.activeCompareAtPrice) !=
                Number.parseFloat(product.activePrice)
            "
          >
            {{ formatPrice(product.delDiaVersion.price.toString()) }}
            <s>{{ formatPrice(product.activeCompareAtPrice.toString()) }}</s>
          </h6>
          <h6 class="product-price" v-else>
            {{ formatPrice(product.delDiaVersion.price.toString()) }}
          </h6>
        </div>
        <!-- .col -->
        <div class="col-12" data-nosnippet>
          <p class="product-desc">
            {{ product.delDiaVersion.shortDescription }}
            <span>{{ product.delDiaVersion.shortDescriptionEmphasis }}</span>
          </p>
        </div>
        <!-- col-12 --> </a
      ><!-- .row -->
      <!--  if NOT Del Dia -->
      <a v-else :href="product.url" class="row">
        <div class="col-8">
          <h6 class="product-title">{{ product.title }}</h6>
        </div>
        <!-- .col -->
        <div class="col-4 text-right" data-nosnippet>
          <h6
            class="product-price discounted"
            v-if="
              product.activeCompareAtPrice &&
              Number.parseFloat(product.activeCompareAtPrice) >
                Number.parseFloat(product.activePrice)
            "
          >
            <s>{{ formatPrice(product.activeCompareAtPrice) }}</s>
            {{ formatPrice(product.activePrice) }}
          </h6>
          <span
            class="savings"
            v-if="
              product.activeCompareAtPrice &&
              Number.parseFloat(product.activeCompareAtPrice) >
                Number.parseFloat(product.activePrice)
            "
          >
            You save
            {{
              percentageSavings(
                product.activePrice,
                product.activeCompareAtPrice
              )
            }}%
          </span>
          <h6 class="product-price" v-else>
            {{ formatPrice(product.activePrice) }}
          </h6>
        </div>
        <!-- .col -->
        <div class="col-12" data-nosnippet>
          <p class="product-desc">
            {{ product.shortDescription }}
            <span>{{ product.shortDescriptionEmphasis }}</span>
          </p>
        </div>
        <!-- col-12 --> </a
      ><!-- .row -->
      <div class="reviews" data-nosnippet>
        <div class="review-stars" v-if="product.reviews.totalReviews > 0">
          <ReviewStars
            :numStars="product.reviews.averageScore"
            :size="formattedStarSize"
            :numReviews="product.reviews.totalReviews"
            baseColor="#F2F2F2"
            fillColor="#B2B2B2"
          />
        </div>
      </div>

      <swiper
        :slidesPerView="'auto'"
        :spaceBetween="2"
        :watchOverflow="false"
        :navigation="true"
        :modules="modules"
        :breakpoints="{
          '768': {
            allowTouchMove: false,
          },
        }"
        class="dot-swiper"
        data-nosnippet
      >
        <!-- when colorways exist -->
        <swiper-slide class="dot-slide" v-for="color in product.colorways">
          <!-- if colorway is called del dia -->
          <div
            class="dot"
            v-if="color.name == 'Del Dia' || color.name == 'Del Día'"
            v-bind:class="color.name === product.activeColor ? 'active' : ''"
            v-on:click="
              switchImages(
                color.name,
                color.image,
                product,
                false,
                color.price,
                color.compareAtPrice,
                color.status
              )
            "
            style="
              background-image: url(https://cdn.shopify.com/s/files/1/0281/7544/t/59/assets/dd-swatch-bg.jpg?v=1654016605);
            "
          >
            <span>{{ color.name }}</span>
          </div>
          <!-- if colorway is not del dia -->
          <div
            class="dot"
            v-else
            v-bind:class="color.name === product.activeColor ? 'active' : ''"
            v-on:click="
              switchImages(
                color.name,
                color.image,
                product,
                false,
                color.price,
                color.compareAtPrice,
                color.status
              )
            "
            :style="{ backgroundColor: color.hexValue }"
          >
            <span>{{ color.name }}</span>
          </div>
        </swiper-slide>

        <!-- color swatch for del dia relative products -->
        <swiper-slide
          class="dot-slide ooak"
          v-if="
            product.hasOwnProperty('delDiaVersion') &&
            product.delDiaVersion.inventory != 'none'
          "
        >
          <div
            class="dot"
            :class="'delDia' === product.activeColor ? 'active' : ''"
            v-on:click="
              switchImages(
                'delDia',
                '',
                product,
                true,
                product.delDiaVersion.price,
                product.delDiaVersion.price
              )
            "
            style="
              background-image: url(https://cdn.shopify.com/s/files/1/0281/7544/t/59/assets/dd-swatch-bg.jpg?v=1654016605);
            "
          >
            <span>One-of-a-Kind</span>
          </div>
        </swiper-slide>
        <!-- .dot-col -->

        <!-- when colorway does not exist (choice is in stock but surprise me is sold out)  -->
        <swiper-slide
          class="dot-slide"
          v-if="product.colorways && product.colorways.length === 0"
        >
          <div
            class="dot active"
            v-if="product.choiceInventory === 'choice'"
            style="
              background-image: url(https://cdn.shopify.com/s/files/1/0281/7544/t/59/assets/dd-swatch-bg.jpg?v=1654016605);
            "
          >
            <span>Del Dia</span>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <!-- .product-details -->
  </div>
  <!-- .ctpx-product-item -->
</template>
<script src="./ctrl-product-card.js"></script>
